import Icon from "../../components/selfcare/Icon.tsx";
import {Link} from "react-router-dom";
import setTitleAndMetaDescription from "../../components/setTitleAndMetaDescription.tsx";
import useDatalayer from "../../components/useDatalayer.tsx";
import Routing from "../../Routing.ts";
import ScrollToTop from "../../components/ScrollToTop.tsx";
import IconArrow from "../../components/icons/IconArrow.tsx";
import IconPdf from "../../components/icons/IconPdf.tsx";

export default function ConditionsPage() {
    ScrollToTop()
    setTitleAndMetaDescription("Hipers aftalevilkår", "Her kan du læse Hipers aftalevilkår for bredbåndsabonnementer. Find og download dine vilkår.")
    useDatalayer()

    return (
        <>
            <section className="conditions">
                <div className="content content--wide">
                    <div className="blurb">
                        <h1 className="heading heading--big">Aftalevilkår</h1>
                        <p>
                            <Link to={Routing.About.Index} className="icon-link icon-link-left icon-link-rotate-180 back-link-widget %s">
                                <Icon component={IconArrow}/> <span className="text">Tilbage</span>
                            </Link>
                        </p>
                    </div>
                    <div className="menugrid">
                        <Link
                            to={"/aftalevilkaar/privat.pdf"}
                            target="_blank"
                            className="item"
                        >
                            <Icon component={IconPdf}/>
                            <span className="headline heading--smaller">Aftalevilkår for privatkunder</span>
                        </Link>
                        <Link
                            to={"/aftalevilkaar/erhverv.pdf"}
                            target="_blank"
                            className="item"
                        >
                            <Icon component={IconPdf}/>
                            <span className="headline heading--smaller">Aftalevilkår for erhvervskunder</span>
                        </Link>
                        <Link
                            to={"/aftalevilkaar/fortrydelsesformular.pdf"}
                            target="_blank"
                            className="item"
                        >
                            <Icon component={IconPdf}/>
                            <span className="headline heading--smaller">Fortrydelsesformular for privatkunder</span>
                        </Link>
                        <Link
                            to={"/aftalevilkaar/5g-tillaeg.pdf"}
                            target="_blank"
                            className="item"
                        >
                            <Icon component={IconPdf}/>
                            <span className="headline heading--smaller">Tillægsvilkår for 5G-internet</span>
                        </Link>
                    </div>
                </div>
            </section>
            <section className="cookies">
                <div className="content content--slim">
                    <div className="blurb">
                        <h2 className="heading heading--big">
                            Cookies på <a href="https://www.hiper.dk/">Hiper.dk</a>
                        </h2>
                    </div>

                    <h3 className="heading heading--montserrat heading--medium">
                        Statistik-cookie
                    </h3>
                    <p>
                        Når du benytter <a href="https://www.hiper.dk/">Hiper.dk</a> accepterer du samtidig, at vi sætter en statistik cookie på din PC.
                        Den gør os i stand til at samle viden om dit besøg i anonymiseret form.
                        De indsamlede data er Hipers ejendom og kan ikke benyttes af andre end Hiper.
                        Vi kan derfor garantere, at de indsamlede data kun benyttes til at forbedre sitet og dokumentere resultater af Hipers kundekommunikation.
                        Statistik cookien leveres af firmaet Google Analytics.
                    </p>

                    <h3 className="heading heading--montserrat heading--medium">
                        3.&nbsp;parts cookies: Sociale medier m.v.
                    </h3>
                    <p>
                        Vi benytter 3.&nbsp;parts cookies fra bl.a. Google, Facebook m.v.
                        Hvis du ikke ønsker disse cookies på din computer skal du afvise dem.
                        Du kan stadig bruge websitet uden at acceptere 3.&nbsp;parts cookies, men indholdet af iframes, integration med sociale medier, videoklip m.m. vises ikke.
                        Det betyder, at du bliver nødt til at acceptere 3.&nbsp;parts cookies, hvis du gerne vil benytte dette indhold.
                    </p>
                    <p>
                        Du kan til enhver tid ændre dit valg øverst på denne side.
                        Bemærk dog, at allerede satte 3.&nbsp;parts cookies kun kan fjernes i din browsers internetindstillinger &ndash; se nedenfor.
                    </p>

                    <h3 className="heading heading--montserrat heading--medium">
                        Tekniske cookies
                    </h3>
                    <p>
                        Vi anvender tekniske cookies, som er en forudsætning for at sitet kan fungere på din enhed.
                    </p>

                    <h3 className="heading heading--montserrat heading--medium">
                        Sådan sletter du cookies
                    </h3>
                    <p>
                        Du kan selv fjerne cookies i din browsers internetindstillinger, se hvordan:
                    </p>
                    <ul className="bullet-list">
                        <li><p>
                            Sletning af cookies i
                            <a href="http://windows.microsoft.com/da-dk/internet-explorer/delete-manage-cookies#ie=ie-11">
                                Internet Explorer &raquo;
                            </a>
                        </p></li>
                        <li><p>
                            Sletning af cookies i
                            <a href="https://support.mozilla.org/da/kb/slet-cookies-fjerne-oplysninger-fra-websteder?redirectlocale=en-US&redirectslug=Deleting+cookies">
                                Mozilla Firefox &raquo;
                            </a>
                        </p></li>
                        <li><p>
                            Sletning af cookies i
                            <a href="https://support.google.com/chrome/answer/95647?hl=da">
                                Google Chrome &raquo;
                            </a>
                        </p></li>
                        <li><p>
                            Sletning af cookies i
                            <a href="https://help.opera.com/en/latest/web-preferences/#cookies">
                                Opera &raquo;
                            </a>
                        </p></li>
                        <li><p>
                            Sletning af cookies i
                            <a href="https://support.apple.com/da-dk/guide/safari/sfri11471/mac">
                                Safari &raquo;
                            </a>
                        </p></li>
                    </ul>

                    <h3 className="heading heading--montserrat heading--medium">
                        Derfor informerer vi om cookies
                    </h3>
                    <p>
                        Alle danske websites er forpligtet til at informere om hvilke cookies, der afsættes på brugerens udstyr.
                        En cookie er en tekstfil, som lægges på din computer eller andet IT udstyr.
                        Den gør det muligt at genkende din computer og samle information om, hvilke sider og funktioner, der besøges med din computer.
                        Cookies indeholder oplysninger i anonymiseret form og anvendes af stort set alle websites.
                        De er i mange tilfælde en forudsætning for at websitet kan fungere.
                    </p>
                </div>
            </section>
        </>
    )
}
